import React from 'react';

const isWindows = () => /win/i.test(window.navigator.platform);

const map = (() => {
  const _map = {};
  // map A-Z
  for (let i = 0; i < 26; i += 1) {
    _map[65 + i] = String.fromCharCode(65 + i);
  }

  // map 0-9
  for (let i = 0; i < 10; i += 1) {
    _map[48 + i] = String.fromCharCode(48 + i);
  }

  // 一些特别的按键
  _map[91] = isWindows() ? 'Meta' : '⌘';
  _map[16] = isWindows() ? 'Shift' : '⇧';
  _map[18] = isWindows() ? 'Alt' : '⌥';
  _map[17] = isWindows() ? 'Ctrl' : '⌘';
  _map[13] = 'Enter';
  _map[27] = 'Esc';
  _map[112] = 'F1';
  _map[113] = 'F2';
  return _map;
})();

const getStyle = theme => {
  const style = {
    display: 'inline-block',
    textAlign: 'center',
    paddingLeft: '5px',
    paddingRight: '5px',
    height: '22px',
    opacity: 0.9,
    borderRadius: '4px',
    backgroundColor: '#343f4b',
    boxShadow: '0 2px 4px 0 rgba(52, 63, 75, 0.1), inset 0 -2px 0 0 #e9ecee, inset 0 -1px 0 0 #f2f4f5',
    marginRight: '6px',
    lineHeight: '22px',
    color: '#fff',
    minWidth: '23px'
  };
  if (theme === 'bigwhite') {
    style.height = 'auto';
    style.paddingLeft = '12px';
    style.paddingRight = '12px';
    style.paddingTop = '9px';
    style.paddingBottom = '9px';
    style.backgroundColor = '#fff';
    style.boxShadow = '0 2px 4px 0 rgba(52, 63, 75, 0.1), inset 0 -2px 0 0 #e9ecee, inset 0 -1px 0 0 #f2f4f5';
    style.border = 'solid 1px #d4dadd';
    style.lineHeight = 'initial';
    style.marginRight = '0px';
  }
  if (theme !== 'dark') {
    return Object.assign(style, {
      backgroundColor: '#fff',
      color: '#969faa'
    });
  }
  return style;
};

const Key = ({ val, theme = 'dark' }) => <span style={getStyle(theme)}>{map[val] || val}</span>;

export default Key;
